import React, { memo } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '../../../components/material-ui/Dialog';
import { TextField } from '../../../components/material-ui/TextField';
import { MenuItem } from '../../../components/material-ui/Menu';
import { FormControl } from '../../../components/material-ui/FormControl';
import { useInputs } from '../../../components/hooks/useInputs';
import { Select } from '../../../components/material-ui/Select';
import { InputLabel } from '../../../components/material-ui/InputLabel';
import { Input } from '../../../components/material-ui/Input';
import { useStyles } from './useStyles';
import { Scope } from '../constants';
import { DialogControls } from '../../../components/DialogControls/DialogControls';

export const FilterNoticeModal = memo((props) => {
    const { hideModal, open, onOk, data } = props;
    const initialData = React.useMemo(() => ({ scope: -1, ...data }), []);
    const { inputs, handleInputChange, setInputs } = useInputs({ initialData });
    const classes = useStyles();
    const { t: translate } = useTranslation();

    const handleOk = () => {
        onOk(inputs);
    };

    const handleChange = React.useCallback((dt) => {
        handleInputChange(dt);
    }, []);

    const handleReset = React.useCallback(() => {
        onOk(initialData);
        setInputs(initialData);
    }, []);

    const actionList = [
        {
            label: translate('close'),
            onClick: hideModal,
        },
        {
            label: translate('clear'),
            onClick: handleReset,
        },
        {
            label: translate('filter'),
            color: 'primary',
            onClick: handleOk,
        },
    ];

    return (
        <Dialog open={open} className="notice-filter-dlg" style={{ zIndex: 1600 }}>
            <DialogTitle className={classes.title}>{translate('modal.filterDialog')}</DialogTitle>
            <DialogContent className={classes.container}>
                <FormControl className={classes.formControl}>
                    <InputLabel id="scopeLabel">{translate('modal.scope')}</InputLabel>
                    <Select
                        labelId="scopeLabel"
                        id="scope"
                        name="scope"
                        value={+get(inputs, 'scope', -1)}
                        onChange={handleChange}
                        input={<Input />}
                        MenuProps={{ style: { zIndex: 1600 } }}
                    >
                        <MenuItem value={-1}>All</MenuItem>
                        {Object.keys(Scope).map((key) => {
                            const { nameEng } = Scope[key];

                            return (
                                <MenuItem value={+key} key={key}>
                                    {nameEng}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        name="number"
                        fullWidth={true}
                        label={translate('modal.number')}
                        value={get(inputs, 'number', '')}
                        onChange={handleInputChange}
                    />
                </FormControl>
                <FormControl className={classes.formControl}>
                    <TextField
                        name="text"
                        fullWidth={true}
                        label={translate('modal.findText')}
                        value={get(inputs, 'text', '')}
                        onChange={handleInputChange}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions className={classes.controls}>
                <DialogControls actions={actionList} />
            </DialogActions>
        </Dialog>
    );
});
